module.exports = __webpack_public_path__ + "static/media/white-swallow.70104464.png";